import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SpinnerEvent } from '../components/shared/spinner/spinner.event';

export abstract class AgilityRiskSpinnerService {
  abstract status: BehaviorSubject<any>;

  abstract start(message?: string);

  abstract stop();
}

@Injectable()
export class SpinnerDefaultService implements AgilityRiskSpinnerService {
  public status: BehaviorSubject<SpinnerEvent> = new BehaviorSubject<SpinnerEvent>(new SpinnerEvent());

  constructor() {
  }

  start(message?: string) {
    this.status.next(new SpinnerEvent(true, message));
  }

  stop() {
    this.status.next(new SpinnerEvent(false));
  }
}
